import {priority} from '@priority-software/priority-proto-api/lib';
import {SubFormsList} from '../../../features/Form/types';

export const prepareSubformsMap = (
    rawSubforms: SubFormsList,
    subformsDesign: priority.netitems.form.IMenuDesign[],
    validatorFn: (sf: priority.netitems.form.ISubform) => boolean
): SubFormsList => {
    if (!subformsDesign?.length) return rawSubforms;

    const orderMap = new Map(subformsDesign.map((d, i) => [d.Name, i]));

    return rawSubforms
        .filter(sf => orderMap.has(sf.Ename) && validatorFn(sf))
        .sort((a, b) => orderMap.get(a.Ename)! - orderMap.get(b.Ename)!);
};
